import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto/';

const flavourOrder: string[] = [
    'Ejendomsforsikring',
    'Privat løsøre- og ansvarsforsikring',
    'Husforsikring',
    'Fritidshusforsikring',
    'Indboforsikring',
    'Indboforsikring til unge',
    'Maskinforsikring',
    'Rejseforsikring',
    'Rejseforsikring til enkeltperson',
    'Bilforsikring',
    'Ulykkesforsikring',
    'Ulykkesforsikring til unge',
    'Børneforsikring',
    'Krydsulykkesforsikring',
    'Arbejdsskadeforsikring',
    'Hundeforsikring',
    'Katteforsikring',
    'Kennelforsikring',
    'Enkeltrejseforsikring',
    'Afbestillingsforsikring til enkeltrejse'
];

const sortCoverablesByFlavourName = (a: CoverableDTO, b: CoverableDTO): number => {
    const orderA = a.flavourName ? flavourOrder.indexOf(a.flavourName) : 0;
    const orderB = b.flavourName ? flavourOrder.indexOf(b.flavourName) : 0;
    return orderA - orderB;
};

const sortCoverablesByFlavourNameFieldsAndId = (a: CoverableDTO, b: CoverableDTO): number => {
    const orderA = a.flavourName ? flavourOrder.indexOf(a.flavourName) : 0;
    const orderB = b.flavourName ? flavourOrder.indexOf(b.flavourName) : 0;
    return (
        (orderA - orderB ||
            Object.entries(b).length - Object.entries(a).length ||
            a.fixedId?.localeCompare(b.fixedId ?? '')) ??
        0
    );
};

const findExternalCaseFlavourNameSortedIndex = (caseDto: ExternaleCaseDTO): number => {
    return flavourOrder.findIndex((flavourName) =>
        caseDto.linkedEntityTextWithLabel?.includes(flavourName)
    );
};

const sortExternalCasesByFlavourName = (a: ExternaleCaseDTO, b: ExternaleCaseDTO): number => {
    const orderA = findExternalCaseFlavourNameSortedIndex(a);
    const orderB = findExternalCaseFlavourNameSortedIndex(b);
    return orderA - orderB;
};

export {
    sortCoverablesByFlavourName,
    sortCoverablesByFlavourNameFieldsAndId,
    sortExternalCasesByFlavourName
};
